/**
 * Lazy product cards for the home-page carousels.
 *
 * Panels that are not shown first render empty with
 * data-lazy-collection="<handle>". The first time such a panel is activated
 * this fetches sections/lazy-product-cards.liquid for that collection via the
 * Section Rendering API and injects the cards into the panel's track.
 *
 *   window.msmLazyCards.load(panel, { limit, track, onDone })
 *
 * After injecting it does what the theme already does for other injected
 * cards (see assets/custom.js): wakes rimg lazy images, re-runs Judge.me
 * badge rendering and the product-grid-item behaviours. Add-to-cart and the
 * quantity stepper are delegated on document by product-card-buttons.js, so
 * they work on the new cards without any wiring.
 */
(function () {
  'use strict';
  if (window.msmLazyCards) return;

  var SECTION = 'lazy-product-cards';
  var cache = {};

  function fetchCards(handle) {
    if (!cache[handle]) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var url = root + 'collections/' + encodeURIComponent(handle) + '?section_id=' + SECTION;
      cache[handle] = fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('lazy cards ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          // the API wraps the section in <div id="shopify-section-…">
          var wrap = doc.querySelector('[id^="shopify-section-"]') || doc.body;
          return wrap.innerHTML;
        })
        .catch(function (e) { delete cache[handle]; throw e; });
    }
    return cache[handle];
  }

  function wake(container) {
    // rimg images carry a transparent placeholder srcset until rimg's
    // IntersectionObserver promotes them; it never sees injected nodes.
    container.querySelectorAll('img[data-rimg="lazy"]').forEach(function (img) {
      img.removeAttribute('srcset');
      img.setAttribute('data-rimg', 'loaded');
    });
    container.dispatchEvent(new CustomEvent('theme:rimg:watch', { bubbles: true }));
    if (window.theme && window.theme.ProductGridItem) {
      container.querySelectorAll('[data-product-item]').forEach(function (item) {
        try { new window.theme.ProductGridItem(item); } catch (e) {}
      });
    }
    if (window.jdgm && typeof window.jdgm.customizeBadges === 'function') {
      try { window.jdgm.customizeBadges(); } catch (e) {}
    }
    if (typeof window.initGridVariants === 'function') {
      try { window.initGridVariants(container); } catch (e) {}
    }
  }

  function load(panel, opts) {
    opts = opts || {};
    var handle = panel.getAttribute('data-lazy-collection');
    if (!handle || panel.getAttribute('data-lazy-state') === 'loaded') {
      if (opts.onDone) opts.onDone(panel, false);
      return Promise.resolve(false);
    }
    if (panel.getAttribute('data-lazy-state') === 'loading') return Promise.resolve(false);
    panel.setAttribute('data-lazy-state', 'loading');
    var track = opts.track || panel.querySelector('.ccc__products-track');
    var limit = parseInt(opts.limit, 10) || 0;

    return fetchCards(handle).then(function (html) {
      if (!track) return false;
      track.innerHTML = html;
      if (limit > 0) {
        var cards = track.querySelectorAll('.ccc__card');
        for (var i = limit; i < cards.length; i++) cards[i].remove();
      }
      panel.setAttribute('data-lazy-state', 'loaded');
      panel.classList.remove('is-lazy-loading');
      wake(track);
      if (opts.onDone) opts.onDone(panel, true);
      return true;
    }).catch(function () {
      panel.setAttribute('data-lazy-state', 'error');
      panel.classList.remove('is-lazy-loading');
      if (track) track.innerHTML = '<p class="ccc__lazy-error">Could not load products. <a href="/collections/' + handle + '">View the collection</a></p>';
      if (opts.onDone) opts.onDone(panel, false);
      return false;
    });
  }

  window.msmLazyCards = { load: load, fetch: fetchCards };
})();
